module.exports = __webpack_public_path__ + "img/panthers-logo.c7dfc57d.png";